/**
 * Extracts the file extension from a File object or a string filename.
 *
 * @param file - The File object or filename string to extract the extension from.
 * @returns The file extension (up to 3 characters), or an empty string if not found.
 */
export function getFileExtension(file?: File | string): string {
  if (!file) {
    return '';
  }

  if (file instanceof File) {
    const ext = file.name.split('.').pop() || '';
    return ext.slice(0, 3);
  }
  const ext = file.split('.').pop() || '';
  return ext.slice(0, 3);
}
